import { Component, OnDestroy } from '@angular/core';
import { NavController, ViewController, NavParams, LoadingController, AlertController, ToastController, ModalController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import io from 'socket.io-client';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { provider } from '../../providers/provider';
import { Subject } from 'rxjs';
import { AppVersion } from '@ionic-native/app-version';

import { Failure } from '../failure/failure';
import { Success } from '../success/success';
import { AddAddressPage } from '../account/addAddress/addAddress';
import { Events } from 'ionic-angular';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import { CreditPaymentPage } from '../credit-payment/credit-payment';
import { mainModule } from 'process';

@Component({
  selector: 'page-confirm',
  templateUrl: 'confirm.html'
})
export class ConfirmPage implements OnDestroy {
  summary: any;
  tot: any;
  valuta: any;
  len: any;
  righe = [];
  riga = {};
  varianti = [];
  variante = {};
  message: any;
  url: any;
  data: any;
  button_text: any;
  message_text: any;
  creditoResiduo: any;
  fidelityCardThreshold: any;
  options: InAppBrowserOptions = {
    location: 'no',
    hardwareback: 'no',
    toolbar: 'no',
  };
  number: any;
  loading: any;
  note: string = '';
  customerInfo: any;
  address;
  slots;
  takeAway = { place: {}, address: '', mode: '', schedule: '', note: '', deliveryCost: 0, deliveryDiscount: 0 };
  takeHome = false;
  loadOrder = 0;
  onAddressChangedSubscription: any;
  // deliveryFees;
  private _onDestroy = new Subject();
  wrongAddress = '';
  baseDate = new Date();
  days = [];
  sendOrderInProgress = false;
  hash = '';
  temporaryCustomer = null;
  homeDiscount = 0;
  shopDiscount = 0;
  totalWithDiscount = 0;
  version = "2";
  takeAwayPlace = {address: '', number: '', name: '', city: ''};
  locale: string;
  appVersion = '';
  getTot = false;
  selectedAddress = {address: '', number: '', country: '', city: ''};
  infoTakeAway = {productsTotal: 0, deliveryCost: 0, discount: 0, minCostThresholdForCustomCost: 0, deliverableOrderThreshold: 0, minimumForCustomDeliveryCostAchieved: false, minimumDeliverableAchieved: false};


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    private iab: InAppBrowser,
    public loadingCtrl: LoadingController,
    public translateService: TranslateService,
    public storage: Storage,
    private modalCtrl: ModalController,
    public viewCtrl: ViewController,
    public AppVersion: AppVersion,
    public events: Events,
    public customizer: CustomizerProvider,
    public provider: provider) {

    storage.get('versione').then((value) => {
      this.AppVersion.getVersionCode().then(version => {
        if (value) {
          if (value.ios) this.appVersion = "ios/" + version
          else if (value.android) this.appVersion = "android/" + version
          else this.appVersion = 'browser'
        } else this.appVersion = 'browser'
      }).catch(error => {
        this.appVersion = 'browser'
      });
    })

    this.url = provider.getUrl();
    
    let data = provider.getMenu();

    if (data.menu.itsClassMenu && data.settings.payment.when == 'PAGADOPO') { 
      data.settings.payment.when = 'PAGAORA';
      data.settings.payment.how.card = true;
      this.data = data;
    } else {
      this.data = data;
    }
    
    // this.data = provider.getMenu();
    this.temporaryCustomer = provider.getTemporaryCustomer();
    this.summary = provider.getCart();
    this.righe = navParams.get('ordine');
    // this.deliveryFees = parseFloat(this.data.menu.deliveryPriceModifiers.freeDeliveryThreshold);
    this.tot = navParams.get('tot');
    this.valuta = navParams.get('valuta');

    // calcolo del totale dal server
    this.calcolaTotale();

    // calcolo dell'impegno dell'ordine
    this.calcoloImpegnoOrdine();

    // populate customer
    this.retrieveCustomer();
    this.getFidelity();
    //this.prepareDiscounts();

    // bind to address changed
    this.events.subscribe('user:updated', (user) => {
      this.retrieveCustomer();
    });

    if(this.righe[0].prod.trendCustomProperties) {
      for (let i=0; i < this.righe[0].prod.trendCustomProperties.futureReservationDays.length;i++) {
        let trendDate = new Date(this.righe[0].prod.trendCustomProperties.futureReservationDays[i]);
        trendDate.setDate(trendDate.getDate());
        trendDate.setHours(0,0,0,0);
        this.days.push(trendDate)
      }
    } else {

      // check for future reservations
      if (this.data.settings.futureReservationDaysStart != undefined && this.data.settings.futureReservationDaysStart > 0) {

        let newDate = new Date();
        console.log(newDate)
        newDate.setDate(newDate.getDate() + this.data.settings.futureReservationDaysStart);
        newDate.setHours(0,0,0,0);
        // search for first day open
        while (provider.isShopClosed(this.data.settings.orari, newDate)) {
          newDate.setDate(newDate.getDate() + 1)
        }
        this.baseDate = newDate;
      }

      // get slots from server
      if (this.data.settings.futureReservationDays != undefined &&
        this.data.settings.futureReservationDays > 0) {
        let maxDays = this.data.settings.futureReservationDays;

        for (let i=0; i < maxDays;i++) {
          let workDate = new Date(this.baseDate.getTime());

          workDate.setDate(workDate.getDate() + i);
          if (i != 0) {
            // days next to first. if the first is today, we should use slots
            // determined based on time too. If the day is next to this, it
            // doesn't matter the hour
            workDate.setHours(0,0,0,0);
          }
          // check if shop is open in specified date
          if (!provider.isShopClosed(this.data.settings.orari,workDate)) {
            this.days.push(workDate);
          }
          else {
            // skip this day
            if(maxDays >= 14) 
              this.days.push(workDate);
            else
              maxDays++;
          }
        }
        // fix base time
        this.baseDate = this.days[0];
      }
    }

    // now, get slots
    this.getSlots();

    // set take home flag automatically is shop is only in home mode
    this.takeHome = (this.data.menu.takeAwayOptions == 'home');

    this.locale = this.translateService.currentLang.toUpperCase();

    // load buttons
    for (let i = 0; i < this.data.settings.safePayAfterButton.length; i++) {
      if (this.translateService.currentLang.toUpperCase() == this.data.settings.safePayAfterButton[i].lingua && this.data.settings.safePayAfterButton[i].contenuto != "") {
        this.button_text = this.data.settings.safePayAfterButton[i].contenuto;
      }
      else if (this.data.settings.safePayAfterButton[i].main) {
        this.button_text = this.data.settings.safePayAfterButton[i].contenuto;
      }
    }

    for (let i = 0; i < this.data.settings.safePayAfterMsgs; i++) {
      if (this.translateService.currentLang.toUpperCase() == this.data.settings.safePayAfterMsgs[i].lingua && this.data.settings.safePayAfterButton[i].contenuto != "") {
        this.message_text = this.data.settings.safePayAfterMsgs[i].contenuto;
      }
      else if (this.data.settings.safePayAfterMsgs[i].main) {
        this.message_text = this.data.settings.safePayAfterMsgs[i].contenuto;
      }
    }

  }

  calcolaTotale() {
      this.getTot = false;
      let obj = {
      idMenu: this.data.menu._id,
      deliveryAddress: {
        address: this.selectedAddress.address,
        number: this.selectedAddress.number,
        city: this.selectedAddress.city,
        country: this.selectedAddress.country
      },
      order: this.righe,
      isFirstOrder: this.provider.isFirstOrder(),
      deliveryMode: this.takeHome ? 'home' : 'shop'
    }
    this.provider.getTotalFromServer(obj).takeUntil(this._onDestroy).subscribe(data => {
      this.infoTakeAway = JSON.parse((<any>data)._body);
      this.takeAway.deliveryCost = this.infoTakeAway.deliveryCost;
      this.takeAway.deliveryDiscount = -this.infoTakeAway.discount;
      this.totalWithDiscount = this.tot - this.infoTakeAway.discount;
      this.getTot = true;
  }, err => {
      //console.log(err)
    });
  }

  calcoloImpegnoOrdine() {
    let prodCost = 0;
    for (let riga of this.summary) {
      if (!riga.prodotto.content.noProductionCost) {
        prodCost = prodCost + riga.quantita
      }
    }

    if(prodCost == 0) {
      this.data.menu.takeAwayOptions = 'shop';
      this.loadOrder = prodCost;
    } else {
      if (this.data.settings.orderWeightIsOne && prodCost !== 0) {
        this.loadOrder = 1;
      } else {
        this.loadOrder = prodCost;
      }
    }
  }

  validationTakeAwayOrder() {
    if(this.data.tavolo.itsHotelRoom || this.data.tavolo.isTakeAway) {
      if(!this.takeAway.schedule) {
        return true;
      }
      else if(!this.takeAway.address && this.takeHome) {
        return true;
      }
      else if(this.wrongAddress != '' && this.takeHome) {
        return true;
      }
      else if(this.totalWithDiscount < this.infoTakeAway.deliverableOrderThreshold) {
        return true;
      }
      else if(!this.infoTakeAway.minimumDeliverableAchieved) {
        return true;
      }
      else if((this.data.settings.businessAddresses.length > 0) && !this.takeHome && this.takeAwayPlace.address == '') {
        return true;
      }
    }
    return false;
  }

  /*prepareDiscounts() {
    let calcolo = this.tot / 100;
    if(this.data.menu.menuDiscount && 
        // questo sconto vale sempre oppure...
        (!this.data.menu.menuDiscount.onlyOnRegistration ||
          // .. solo in fase di registrazione e siamo in fase di registrazione
          (this.data.menu.menuDiscount.onlyOnRegistration && this.provider.isFirstOrder()))) {
        // calcola lo sconto da applicare
        if(this.data.menu.menuDiscount.homeValue != "0.00") {
          this.data.menu.menuDiscount.homeIsPercentage ? this.homeDiscount = parseFloat((Math.ceil((this.data.menu.menuDiscount.homeValue * calcolo) * 20 - 0.5)/20).toFixed(2)) : this.homeDiscount = this.data.menu.menuDiscount.homeValue;
        }
        if(this.data.menu.menuDiscount.shopValue != "0.00") {
          this.data.menu.menuDiscount.shopIsPercentage ? this.shopDiscount = parseFloat((Math.ceil((this.data.menu.menuDiscount.shopValue * calcolo) * 20 - 0.5)/20).toFixed(2)) : this.shopDiscount = this.data.menu.menuDiscount.shopValue;
        }
    }
    this.totalWithDiscount = this.tot - this.infoTakeAway.discount;
  }*/

  takeAwayHome(event) {
    this.takeHome = event.value;
    this.totalWithDiscount = this.tot - this.infoTakeAway.discount;
    if(event.value) {
      this.takeAway.place = {};
      this.takeAwayPlace = {address: '', number: '', name: '', city: ''};
    } else {
      this.wrongAddress = "";
    }
  }

  getFidelity() {
    this.storage.get(this.data.settings.customercode).then((hash) => {
      this.hash = hash;
      this.provider.getCardBalance(hash).takeUntil(this._onDestroy).subscribe(data => {
        let tessera = JSON.parse((<any>data)._body);
        this.creditoResiduo = tessera.valore;
        this.fidelityCardThreshold = tessera.valore_minimo;
      }, err => {
        this.hash = '';
      });
    })
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  mapAddressCode() {
    let items = JSON.parse(sessionStorage.getItem('comuni'));

    for (let address of this.customerInfo.addresses) {
      items.filter((item) => {
        if (item.name.toLowerCase() == (address.city).toLowerCase()) {
          address.code = item.code;
        }
      });
    }
  }

  changeTakeAwayPlace(event) {
    //console.log(event)
    this.takeAwayPlace = event;
  }

  controlAddress(event) {
    let address = this.takeAway.address;
    // exit immediately if no address is entered or we are in hotel mode
    if (!address || this.data.tavolo.itsHotelRoom)
      return;
    // process address
    this.customerInfo.addresses.filter((item) => {
      if (item.id == address) {
        this.selectedAddress = item;
        // enable the wrong address prompt
        this.translateService.get("INVALID_ADDRESS").takeUntil(this._onDestroy).subscribe(msg => {
          this.wrongAddress = msg;
          this.provider.getShops(item.code).subscribe(shops => {
            let negozi = JSON.parse((<any>shops)._body);
            negozi.filter((negozio) => {
              if (negozio.customercode == this.data.settings.customercode) {
                this.wrongAddress = '';
              }
            })
          }, err => {
            console.log('No restaurants found');
          });
        });
      }
    })
  }

  getSlots() {
    this.provider.getSlots(this.baseDate.toISOString()).takeUntil(this._onDestroy).subscribe(slots => {
      this.slots = JSON.parse((<any>slots)._body);
      this.takeAway.schedule = null;
    }, err => {
      console.log(err);
    });
  }

  retrieveCustomer() {
    // in hotel mode, recover hotel data
    if (this.data.tavolo.itsHotelRoom) {
      //Use hotel room data
      this.customerInfo = this.data.tavolo.hotelRoom;
    } else if (this.temporaryCustomer) {
      //using data handed from the order manager redirection
      this.customerInfo = this.temporaryCustomer;
      this.mapAddressCode();
    } else {
      // get customer from storage
      this.storage.get('customer').then(customer => {
        this.customerInfo = JSON.parse((<any>customer))
        if (this.data.tavolo.isTakeAway) this.mapAddressCode();
      }, err => console.error(err))
    }
  }

  addAddress() {
    let modal = this.modalCtrl.create(AddAddressPage);
    modal.onDidDismiss(data => {
      this.retrieveCustomer();
      if (this.customerInfo.addresses.length > 0)
        this.takeAway.address = this.customerInfo.addresses[0].id;
    });
    modal.present();
  }

  /*getDeliveryFees() {
    // calcolo costo consegna
    if (this.totalWithDiscount < this.deliveryFees) {
      if (this.data.menu.deliveryPriceModifiers.chargeType == 'percent') {
        this.takeAway.deliveryCost = (this.tot * parseFloat(this.data.menu.deliveryPriceModifiers.chargeFee)) / 100;
      } else {
        this.takeAway.deliveryCost = parseFloat(this.data.menu.deliveryPriceModifiers.chargeFee);
      }
      return this.takeAway.deliveryCost
    } else {
      return undefined;
    }
  }*/

  isSlotFree(slot) {
    if (this.data.settings.ordersBySlot != 0) {
      let isFull = this.data.settings.ordersBySlot - slot.load;

      if ((isFull - this.loadOrder) < 0) {
        return true;
      } else {
        return false;
      }
    } else return false;
  }

  callback(teste) {
    console.log(teste)
  }

  sendOrder(when, how) {
    this.loadingCtrl.create({
      content: '<ion-spinner name="circles"></ion-spinner>'/*,
      dismissOnPageChange: true*/
    });
    // loading.present();

    // disable double press
    this.sendOrderInProgress = true;

    let disconnectTimeout = null, pagandoTimeout = null, concluso = false;
    this.translateService
    .get(['ERROR_MESSAGE', 'SUCCESS_MESSAGE', 'SERVER_NOT_RESPONDING',
          'PAGAMENTO_OK','PAGAMENTO_NOT_OK', 'PAGAMENTO_INTERROTTO',
          'E1000','E1001','E1002','E1003','E1004',
          'E1005','E1006','E1007','E1008','E1009','E1010'])
    .takeUntil(this._onDestroy)
    .subscribe(msg => {
      if (this.data.tavolo.isTakeAway || this.data.tavolo.itsHotelRoom) {
        if (!this.data.tavolo.itsHotelRoom) {
          if (this.data.menu.takeAwayOptions == 'home&shop') {
            if (this.takeHome) {
              this.takeAway.mode = 'home';
            } else {
              this.takeAway.mode = 'shop';
            }
          } else {
            this.takeAway.mode = this.data.menu.takeAwayOptions;
          }
        } else if (this.data.menu.itsClassMenu) { 
          this.takeAway.mode = 'classroom';
        } else {
          // for hotel mode
          this.takeAway.mode = 'home';
        }

        if (this.data.settings.orderWeightIsOne) {
          (<any>this.takeAway.schedule).load = 1;
        } else {
          (<any>this.takeAway.schedule).load = this.loadOrder;
        }

        if (this.wrongAddress !== '') {
          return;
        }
        if(this.takeAway.mode == 'shop') 
          this.takeAway.address = '';
        
      } else if (this.data.tavolo.requireRegisteredUser) {
        if (this.data.menu.itsClassMenu) { 
          this.takeAway.mode = 'classroom';
        } else {
          this.takeAway.mode = '';
        }

        if (this.wrongAddress !== '') {
          return;
        }
      } else {
        // normal order without delivery and not hotel mode
        this.customerInfo = null;
      }

      this.provider.postOrdini(this.hash, how, when, this.righe, this.tot, this.customerInfo, this.takeAway, this.version, this.appVersion)
      .map(res => res.json())
      .takeUntil(this._onDestroy)
      .subscribe(
        ordine => {
          if (ordine.hasOwnProperty('_id')) {
            // reset sendOrderInProgress
            this.sendOrderInProgress = false;

            // switch on how
            switch (how) {
              case 'NONE':
              case 'PREPAIDCARD':
                this.navCtrl.push(Success, { message: msg.SUCCESS_MESSAGE, tot: this.tot, valuta: this.valuta, takeaway: this.data.tavolo.isTakeAway, deliveryCost: this.takeAway.deliveryCost, deliveryDiscount: this.takeAway.deliveryDiscount});
                break;
              case 'SAFEPAYAFTER':
                this.navCtrl.push(Success, { message: this.message_text, tot: this.tot, valuta: this.valuta, takeaway: this.data.tavolo.isTakeAway, deliveryCost: this.takeAway.deliveryCost, deliveryDiscount: this.takeAway.deliveryDiscount});
                break;
              case 'SELLA':
                this.navCtrl.push(CreditPaymentPage, { order: ordine, message: msg.SUCCESS_MESSAGE, tot: this.tot, valuta: this.valuta, takeaway: this.data.tavolo.isTakeAway, deliveryCost: this.takeAway.deliveryCost, deliveryDiscount: this.takeAway.deliveryDiscount});
                this.viewCtrl.dismiss();
                break;
              case 'BRAINTREE':
                let url = this.url + '/ordini/checkouts/' + ordine._id;
                const browser = this.iab.create(url, "_blank", this.options);
                const socket = io(this.url, { path: `/socket-ordini`, transports: ['websocket'], upgrade: false });
                browser.show();
                socket.on('connect', () => {
                  clearTimeout(disconnectTimeout);
                  socket.emit('join', ordine._id);
                  if (pagandoTimeout == null) {
                    pagandoTimeout = setTimeout(() => {
                      concluso = true
                      socket && socket.close()
                      browser && browser.close()
                      this.navCtrl.push(Failure, { message: msg.SERVER_NOT_RESPONDING })
                    }, 10000);
                  }
                });
                socket.on('message', (data) => {
                  if (data === 'PAGATO!') {
                    clearTimeout(pagandoTimeout);
                    clearTimeout(disconnectTimeout);
                    concluso = true;
                    socket.emit('leave', ordine._id);
                    browser.close();
                    socket.close();
                    this.navCtrl.push(Success, { message: msg.PAGAMENTO_OK, tot: this.tot, valuta: this.valuta, takeaway: this.data.tavolo.isTakeAway });
                  }
                  if (data === 'NONPAGATO!') {
                    clearTimeout(pagandoTimeout);
                    clearTimeout(disconnectTimeout);
                    concluso = true;
                    socket.emit('leave', ordine._id);
                    browser.close();
                    socket.close();
                    let toast = this.toastCtrl.create({
                      message: msg.PAGAMENTO_NOT_OK,
                      duration: 3000
                    });
                    toast.present();
                  }
                  if (data === 'STOPAGANDO!') {
                    clearTimeout(pagandoTimeout);
                    pagandoTimeout = setTimeout(() => {
                      concluso = true;
                      socket && socket.close();
                      browser && browser.close();
                      this.provider.getOrdiniCheck(ordine._id).map(res => res.json()).takeUntil(this._onDestroy).subscribe(data => {
                        let toast = this.toastCtrl.create({
                          message: msg.PAGAMENTO_INTERROTTO,
                          duration: 3000
                        });
                        toast.present();
                      },
                        err => {
                          let toast = this.toastCtrl.create({
                            message: "Impossibile recuperare lo stato dell'ordine",
                            duration: 3000
                          });
                          toast.present();
                        });
                    }, 10000)
                  }
                  if (data == 'ANNULLA!') {
                    clearTimeout(pagandoTimeout)
                    clearTimeout(disconnectTimeout)
                    concluso = true;
                    socket && socket.close();
                    browser && browser.close();
                    pagandoTimeout = setTimeout(() => {
                      this.provider.getOrdiniCheck(ordine._id).map(res => res.json()).takeUntil(this._onDestroy).subscribe(data => {
                        let toast = this.toastCtrl.create({
                          message: msg.PAGAMENTO_INTERROTTO,
                          duration: 3000
                        });
                        toast.present();
                      },
                        err => {
                          let toast = this.toastCtrl.create({
                            message: "Impossibile recuperare lo stato dell'ordine",
                            duration: 3000
                          });
                          toast.present();
                        });
                    }, 1000)
                  }
                });
                socket.on('disconnect', () => {
                  clearTimeout(disconnectTimeout);
                  if (!concluso) {
                    disconnectTimeout = setTimeout(() => {
                      concluso = true;
                      socket && socket.close();
                      browser && browser.close();
                      this.navCtrl.push(Failure, { message: msg.SERVER_NOT_RESPONDING })
                    }, 10000)
                  }
                });
                break;
              default:
                console.log('ERRORE: ' + how);
                break;
            }
          }
        },
        err => {
          let message: string;
          switch (err._body) {
            case 'E1000':
            case 'E1001':
            case 'E1002':
            case 'E1003':
            case 'E1004':
            case 'E1005':
            case 'E1006':
            case 'E1007':
            case 'E1008':
            case 'E1009':
            case 'E1010':
            case 'E1011':
              message = err._body + ' - ' + msg[err._body];
              break;
            default:
              message = msg.E1000;
              break;
          }
          // errore
          console.log(err._body)
          //this.provider.clearApp();
          let toast = this.toastCtrl.create({
            message: message,
            closeButtonText: 'Ok',
            showCloseButton: true
          });
          toast.present();
          // loading.dismiss();
          // reset send order flag
          this.sendOrderInProgress = false;
        }
      );
    });
  }

  compareDate(d1,d2) {
    var dt1 = new Date(d1.getTime());
    var dt2 = new Date(d2.getTime());
    dt1.setHours(0,0,0,0);
    dt2.setHours(0,0,0,0);
    return (dt1.getTime() === dt2.getTime());
  }

  isToday(day : Date) : Boolean {
    return this.compareDate(day, new Date());
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/confirm/confirm.ts